import {homeRentAmt} from './homeRentCalc';
import {healthInsCalcAmt} from './healthInsCalc';
import {transportCostCalcAmt} from './transportCostCalc';
import ConfigFile from '../../datasets/config_file';
import { createTableItem } from '../AssetsExpenses/create_table_item';
import { autoInsuranceCostCalcAmt } from './autoInsuranceCostCalc';

export const monthlyExpenseAmt = (homeCost, roommates, bedrooms, homeName, jobHealthInsInd, carMPG,
            currentGameDate, startGameDate, carValue, carSize) => {
          
     const expenseArr = [];
     const miscCost=ConfigFile.gameStartItems.monthlyMiscCost;
     const carInsExpObj = autoInsuranceCostCalcAmt(carValue, carSize, currentGameDate);
     const carInsAmt = carInsExpObj.expAmount;
     const rentersInsAmt = ConfigFile.insurance.rentersInsAmt;
     const phoneExpAmt = ConfigFile.gameStartItems.phoneExpAmt;
     const busPassAmt = ConfigFile.gameStartItems.busPassAmt;
     var expenseObj = " ";
    
     expenseObj = homeRentAmt(homeCost, roommates, bedrooms, homeName, currentGameDate);
     expenseArr.push(expenseObj);
        
     expenseObj = healthInsCalcAmt(jobHealthInsInd, currentGameDate, startGameDate);
     expenseArr.push(expenseObj);

     expenseObj = createTableItem("rentersIns", "", currentGameDate, rentersInsAmt, "", false)
     expenseArr.push(expenseObj);

     expenseObj = createTableItem("phone", "", currentGameDate, phoneExpAmt, false);
     expenseArr.push(expenseObj);
  
     if (carSize === 50){
            expenseObj = createTableItem("busPass", "", currentGameDate, busPassAmt, "", false);
            expenseArr.push(expenseObj);
     }else{
          expenseObj = createTableItem("carIns", "", currentGameDate, carInsAmt, "", false)
            expenseArr.push(expenseObj);

            expenseObj = transportCostCalcAmt(carMPG, currentGameDate)
            expenseArr.push(expenseObj);
     }  
     
     expenseObj = {expItem: "Misc Expenses", expDesc: "Food, Clothes, Personal Items, etc.",
           expAmount: miscCost, expStartDate: currentGameDate, expNbrMonths: "-1", chargeCreditCard: true};   ; 
     expenseArr.push(expenseObj);
    
     return expenseArr;
 }

